/*
 * Interface strings, Spanish.
 *
 * The "ui" bucket: everything outside the calculators. Every language the
 * picker offers has a full file here, so no English leaks into a translated
 * interface. Calculator text lives in i18n/calc, which is English and Spanish
 * only. Legal and disclaimer text is in neither: it stays English everywhere,
 * with legal.englishGoverning beside it.
 *
 * Plural keys end _one/_other and are chosen by Intl.PluralRules for this
 * language; Chinese, Thai, Vietnamese and Indonesian have one form, so they
 * carry only _other and every count lands there.
 */

/* NOT REVIEWED BY A NATIVE SPEAKER. */

const strings = {
  "landing.lead": "Inicia sesión con tu cuenta de AquaNetica para continuar.",
  "landing.signIn": "Iniciar sesión",
  "landing.signUpFree": "El registro es gratuito.",
  "common.close": "Cerrar",
  "common.cancel": "Cancelar",
  "profile.title": "Perfil del sistema · {name}",
  "profile.subtitle": "Gia lo usa para ajustar cada respuesta de este proyecto. Deja en blanco los campos que no apliquen.",
  "profile.species": "Especie",
  "profile.speciesPlaceholder": "p. ej. salmón del Atlántico",
  "profile.systemType": "Tipo de sistema",
  "profile.select": "Selecciona…",
  "profile.sys.ras": "RAS (recirculación)",
  "profile.sys.flow": "Flujo abierto",
  "profile.sys.pond": "Estanque",
  "profile.sys.cage": "Jaula / balsa marina",
  "profile.sys.hatchery": "Hatchery / criadero",
  "profile.sys.other": "Otro",
  "profile.volume": "Volumen total (L)",
  "profile.temp": "Temperatura objetivo (°C)",
  "profile.lifeStage": "Etapa de vida",
  "profile.lifeStagePlaceholder": "smolt, juvenil, reproductores",
  "profile.location": "Ubicación",
  "profile.locationPlaceholder": "p. ej. Los Lagos, Chile",
  "profile.notes": "Notas adicionales",
  "profile.notesPlaceholder": "Cualquier otra cosa que Gia deba saber de este sistema",
  "profile.save": "Guardar perfil",
  "help.title": "Acerca de Gia y aviso legal",
  "help.about": "Gia es una asistente de IA para operadores de acuicultura, con calculadoras de ingeniería integradas. Responde a partir de material de referencia y conocimiento general para ayudarte a analizar sistemas, calidad del agua y equipos.",
  "legal.englishGoverning": "Los términos y el aviso legal se ofrecen en inglés. La versión en inglés es la que prevalece.",
  "feature.notNow": "Ahora no",
  "feature.seePlans": "Ver planes",
  "lang.title": "Idioma",
  "lang.sub": "Define la interfaz y el idioma en que responde Gia, sin importar en qué idioma escribas.",
  "lang.auto": "Automático (según mi navegador y mi pregunta)",
  "pe.timeline.ASAP": "Lo antes posible",
  "pe.timeline.1–3 months": "1–3 meses",
  "pe.timeline.Just researching": "Solo estoy investigando",
  "pe.condition.New": "Nuevo",
  "pe.condition.Used": "Usado",
  "pe.condition.Either": "Cualquiera",
  "pe.missing.quantity": "cuántas unidades necesitas",
  "pe.missing.city": "adónde se envía",
  "pe.missing.date": "cuándo lo necesitas",
  "pe.nudge": "Los proveedores no suelen poder cotizar sin saber {list}. Puedes enviarla de todos modos.",
  "pe.err.name": "Añade tu nombre para saber a quién responder.",
  "pe.err.email": "Añade tu correo electrónico para que podamos responderte.",
  "pe.err.emailInvalid": "Ese correo no parece correcto; revísalo, por favor.",
  "pe.err.quantity": "Indica cuántas unidades necesitas.",
  "pe.err.city": "Indica la ciudad de entrega.",
  "pe.err.send": "No pudimos enviar tu solicitud. Inténtalo de nuevo.",
  "pe.err.network": "No pudimos conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.",
  "pe.title": "Ayúdame a conseguir esto",
  "pe.thanks": "Gracias. Te escribiremos a {email}.",
  "pe.done": "Listo",
  "pe.whatYouNeed": "Lo que necesitas",
  "pe.equipment": "Equipo",
  "pe.suggestedModels": "Modelos sugeridos:",
  "pe.hideDetails": "Ocultar detalles",
  "pe.editDetails": "Editar detalles",
  "pe.item": "Artículo que necesitas",
  "pe.specs": "Detalles y dimensionamiento",
  "pe.name": "Tu nombre",
  "pe.email": "Correo electrónico (para responderte)",
  "pe.when": "¿Cuándo lo necesitas?",
  "pe.quantity": "¿Cuántas unidades necesitas?",
  "pe.quantityPlaceholder": "p. ej. 2 unidades",
  "pe.city": "Ciudad de entrega",
  "pe.cityPlaceholder": "¿Adónde hay que enviarlo?",
  "pe.neededBy": "Fecha límite (opcional)",
  "pe.condition": "¿Nuevo o usado? (opcional)",
  "pe.budget": "Presupuesto aproximado (opcional)",
  "pe.amount": "Importe",
  "pe.budgetAmount": "Importe del presupuesto",
  "pe.budgetCurrency": "Moneda del presupuesto",
  "pe.notSure": "No lo sé",
  "pe.note": "¿Algo más? (opcional)",
  "pe.notePlaceholder": "Cualquier otro dato que nos ayude a encontrar lo adecuado.",
  "pe.hideFarm": "Ocultar datos de la granja",
  "pe.addFarm": "Añadir datos de la granja (opcional)",
  "pe.farm": "Nombre de la granja o empresa",
  "pe.country": "País",
  "pe.sending": "Enviando…",
  "pe.send": "Enviar solicitud",
  "pe.reassurance": "Sin compromiso. Una persona de AquaNetica te responderá por correo electrónico.",
  "toolbar.answerLanguage": "Idioma: {name}",
  "toolbar.answerLanguageTitle": "Idioma",
  "project.namePrompt": "¿Nombre del proyecto?",
  "project.renamePrompt": "Cambiar nombre del proyecto:",
  "project.deleteWithChats": "¿Eliminar el proyecto «{name}» y su chat?",
  "project.deleteWithChats_one": "¿Eliminar el proyecto «{name}» y su chat?",
  "project.deleteWithChats_other": "¿Eliminar el proyecto «{name}» y sus {count} chats?",
  "project.delete": "¿Eliminar el proyecto «{name}»?",
  "file.proTitle": "Los mensajes con archivo son una función Pro",
  "file.proMessage": "Tu plan no incluye mensajes con archivo. Pásate a Pro para adjuntar fichas técnicas, planos y fotos que Gia pueda leer. Un mensaje con archivo es cualquier mensaje que envías mientras hay un archivo adjunto.",
  "file.badType": "Adjunta una imagen (JPG, PNG, GIF, WEBP), un PDF, un archivo de Word, Excel o PowerPoint (.docx, .xlsx, .pptx) o un archivo de texto o código (.txt, .md, .csv, .json, .r, .py).",
  "file.tooLarge": "El archivo es demasiado grande. Los adjuntos deben pesar menos de 20 MB.",
  "file.unreadable": "Gia no pudo leer ese archivo. Si está protegido con contraseña o es un .doc, .xls o .ppt antiguo, guárdalo como .docx, .xlsx o .pptx sin contraseña y vuelve a adjuntarlo.",
  "file.noText": "Ese archivo no tiene texto que Gia pueda leer. Si es un escaneo o casi todo imágenes, adjúntalo como PDF o como imagen.",
  "file.tooBig": "Ese archivo es demasiado grande para que Gia lo lea de una vez. Divídelo en archivos más pequeños o adjunta solo la parte que necesitas.",
  "file.notText": "Ese archivo no es texto plano, aunque su nombre lo indique. Guárdalo como texto (UTF-8) y vuelve a adjuntarlo.",
  "chat.errSomething": "Lo siento, algo salió mal: {detail}",
  "chat.errNoBackend": "Lo siento, no pude conectar con la base de conocimiento. Comprueba que el backend esté en marcha en el puerto 3001.",
  "file.attached": "· adjunto a este chat",
  "file.left": "{count} mensaje con archivo restante este mes",
  "file.left_one": "{count} mensaje con archivo restante este mes",
  "file.left_other": "{count} mensajes con archivo restantes este mes",
  "file.detachTitle": "Quitar el archivo: deja de contar para tus mensajes con archivo",
  "file.detachLabel": "Quitar archivo",
  "file.detach": "Quitar",
  "file.explain": "Cada mensaje que envíes con este archivo adjunto cuenta como un mensaje con archivo. Quítalo cuando Gia ya no necesite consultarlo.",
  "file.reattachHint": "{name}: vuelve a adjuntarlo para seguir preguntando sobre él",
  "file.reattachTitle": "Volver a adjuntar el archivo",
  "file.reattach": "Volver a adjuntar",
  "usage.questions": "{left} de {limit} pregunta restante este mes",
  "usage.questions_one": "{left} de {limit} pregunta restante este mes",
  "usage.questions_other": "{left} de {limit} preguntas restantes este mes",
  "usage.questionsShort": "{left}/{limit} pregunta restante",
  "usage.questionsShort_one": "{left}/{limit} pregunta restante",
  "usage.questionsShort_other": "{left}/{limit} preguntas restantes",
  "usage.files": "{left} de {limit} mensaje con archivo",
  "usage.files_one": "{left} de {limit} mensaje con archivo",
  "usage.files_other": "{left} de {limit} mensajes con archivo",
  "usage.leftShort": "Queda {left} pregunta",
  "usage.leftShort_one": "Queda {left} pregunta",
  "usage.leftShort_other": "Quedan {left} preguntas",
  "usage.remaining": "{left} / {limit} pregunta restante",
  "usage.remaining_one": "{left} / {limit} pregunta restante",
  "usage.remaining_other": "{left} / {limit} preguntas restantes",
  "usage.upgrade": "Mejorar plan",
  "wall.daily": "Has alcanzado el límite de mensajes de hoy",
  "wall.feature": "El plan {plan} no incluye esto",
  "wall.featureYour": "Tu plan no incluye esto",
  "wall.files": "Has usado los {limit} mensajes con archivo de tu plan {plan} este mes",
  "wall.questions": "Has usado las {limit} preguntas de tu plan {plan} este mes",
  "wall.generic": "Has alcanzado un límite de tu plan",
  "wall.region": "Límite de preguntas alcanzado",
  "wall.refresh": "Tus preguntas del plan {plan} se renuevan el día 1.",
  "wall.refreshNoPlan": "Tus preguntas se renuevan el día 1.",
  "wall.stayFree": "Las calculadoras siguen siendo gratuitas e ilimitadas, y todos tus chats anteriores siguen aquí para leerlos.",
  "wall.upgrade": "Mejora tu plan en aquanetica.com",
  "sidebar.hide": "Ocultar barra lateral",
  "sidebar.search": "Buscar chats…",
  "sidebar.newChat": "+ Nuevo chat",
  "sidebar.newProject": "+ Proyecto",
  "sidebar.tools": "🛠️ Herramientas",
  "sidebar.backToGia": "Volver a Gia",
  "sidebar.calculator": "Calculadora",
  "sidebar.empty": "Aún no hay chats. Pregúntale lo que quieras a Gia para empezar.",
  "sidebar.profileSet": "Perfil del sistema configurado",
  "sidebar.newInProject": "Nuevo chat en este proyecto",
  "sidebar.editProfile": "Editar perfil",
  "sidebar.rename": "Cambiar nombre",
  "sidebar.delete": "Eliminar",
  "sidebar.projectEmpty": "Aún no hay chats",
  "sidebar.noMatches": "No hay resultados para «{q}»",
  "sidebar.signedIn": "Sesión iniciada",
  "sidebar.signOut": "Cerrar sesión",
  "sidebar.signingOut": "Cerrando sesión…",
  "signout.title": "Cerrar sesión",
  "signout.body": "Se cerrará tu sesión en AquaNetica IQ y en aquanetica.com. Los documentos subidos y las valoraciones de respuestas se eliminan siempre de este dispositivo. Todo lo demás que hayas guardado se queda aquí para cuando vuelvas a entrar.",
  "signout.alsoClear": "Eliminar también mi trabajo guardado en este dispositivo: conversaciones, proyectos y cálculos",
  "signout.irreversible": "Esta eliminación adicional es permanente. Ese trabajo solo se guarda en este navegador, así que no hay copia para restaurar.",
  "signout.confirm": "Cerrar sesión",
  "sidebar.communityTitle": "Volver a la comunidad de AquaNetica (se abre en una pestaña nueva)",
  "sidebar.community": "Volver a AquaNetica",
  "sidebar.help": "Ayuda y aviso legal",
  "drop.label": "Suelta el archivo para adjuntarlo",
  "toolbar.showSidebar": "Mostrar barra lateral",
  "toolbar.toggleSidebar": "Mostrar u ocultar la barra lateral",
  "toolbar.newChat": "Nuevo chat",
  "toolbar.inProject": "En el proyecto:",
  "toolbar.home": "Volver a la comunidad de AquaNetica",
  "toolbar.homeTitle": "Volver a AquaNetica (se abre en una pestaña nueva)",
  "toolbar.calc": "Abrir calculadora",
  "toolbar.theme": "Cambiar tema",
  "hero.title": "¿En qué puedo ayudarte?",
  "hero.calibrated": "Gia está ajustada al perfil del sistema de este proyecto.",
  "hero.noProfile": "Aún no hay perfil del sistema. Haz clic en ⚙ en el proyecto para crearlo.",
  "hero.subtitle": "Pregunta lo que quieras sobre sistemas acuícolas, calidad del agua o equipos.",
  "composer.attachTitle": "Adjuntar una imagen o un PDF",
  "composer.attachLabel": "Adjuntar un archivo",
  "composer.send": "Enviar",
  "answer.copyTitle": "Copiar respuesta",
  "answer.copied": "Copiado",
  "answer.copy": "Copiar",
  "answer.retryTitle": "Volver a hacer esta pregunta",
  "answer.retryLabel": "Reintentar respuesta",
  "answer.retry": "Reintentar",
  "answer.good": "Buena respuesta",
  "answer.bad": "Mala respuesta",
  "answer.sourcing": "¿Necesitas ayuda para conseguirlo? →",
  "answer.searching": "Buscando en la biblioteca de documentos…",
  "answer.scrollLatest": "Ir a lo más reciente",
  "sidebar.otherChats": "Otros",
  "trial.have": "¿Tienes un código?",
  "trial.title": "Código de prueba",
  "trial.placeholder": "Escribe tu código de prueba",
  "trial.submit": "Canjear",
  "trial.checking": "Comprobando…",
  "trial.invalid": "Ese código no es válido. Revísalo e inténtalo de nuevo.",
  "trial.error": "No pudimos comprobar ese código. Inténtalo de nuevo.",
  "trial.success": "Prueba de Pro activada. Tienes 75 preguntas y 10 mensajes con archivo al mes hasta el {date}.",
  "trial.active": "Prueba Pro hasta {date}",
  "sidebar.planTrial": "Prueba de {plan}",
  "sidebar.managePlan": "Gestionar plan",
  "trial.ends": "La prueba termina el {date}",
  "pe.consent": "Acepto que los datos de mi solicitud se compartan con AquaNetica y con los proveedores a los que se contacte en mi nombre, y acepto los {terms} y la {privacy}.",
  "pe.consentTerms": "Términos del servicio",
  "pe.consentPrivacy": "Política de privacidad",
};

export default strings;
